var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDependant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0475 16.9707C65.3081 13.6158 66.4481 10.1144 65.6175 7.00381C63.7121 2.55781 54.7224 0.473236 50.4067 1.25495C47.7032 5.79866 48.827 11.401 49.3155 16.5798L65.0475 16.9707Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1328 16.7753V1.66211C60.8134 2.52525 64.4777 4.34925 65.6177 6.98754C66.432 10.0981 65.292 13.6158 65.0477 16.9544L57.1328 16.759V16.7753Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 48.3866C59.3777 48.4191 61.7391 48.3214 64.0517 48.0771V26.808L63.2537 26.466C61.5111 25.7006 59.3614 24.8211 57 24.5117V48.4029V48.3866Z",
    fill: "#B2D8DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0048 48.3866C54.6108 48.4191 52.2657 48.3214 49.9531 48.0771V26.808L50.7511 26.466C52.4937 25.7006 54.6597 24.8211 57.0048 24.5117V48.4029V48.3866Z",
    fill: "#B2D8DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9688 20.3086H62.0333V26.3832C58.6785 29.054 55.3236 29.1517 51.9688 26.3832V20.3086Z",
    fill: "#E0AC7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.852 7.85035C51.4189 7.5735 50.0671 9.03921 49.8066 10.4561C49.5623 11.7752 49.3994 13.1106 49.3506 14.4624C49.318 14.4624 49.5297 14.4624 49.2366 14.4624C48.9434 14.4624 48.0151 14.6741 48.0477 15.9281C48.0803 16.8564 48.8946 19.5761 49.9531 19.1364C51.5003 23.2729 53.5849 25.6181 56.9886 26.4486C57.0374 26.3346 57.07 26.4161 57.1189 26.3835V8.27378C55.7509 8.27378 54.3666 8.1435 52.8357 7.83407L52.852 7.85035Z",
    fill: "#F2C196"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2831 7.85035C62.7163 7.5735 64.068 9.03921 64.3286 10.4561C64.5566 11.7752 64.7357 13.1106 64.7846 14.4624C64.8171 14.4624 64.6054 14.4624 64.8986 14.4624C65.1917 14.4624 66.12 14.6741 66.0874 15.9281C66.0549 16.8564 65.2406 19.5761 64.182 19.1364C62.6186 23.3381 60.5014 25.6506 57 26.4486V8.27378C58.368 8.27378 59.7523 8.1435 61.2831 7.83407V7.85035Z",
    fill: "#EBB688"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9997 28.4355H58.726L57.9932 31.1553H56.9997H56.0063L55.2734 28.4355H56.9997Z",
    fill: "#63C0DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9996 31.0742L58.6999 41.4156L57.0062 44.5099L55.3125 41.4156L56.0128 31.0742H57.9996Z",
    fill: "#63C0DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0037 28.4352L54.056 31.3014L50.75 26.4646L51.9714 25.7969C53.2091 27.0997 54.9029 27.9303 57.0037 28.4352Z",
    fill: "#F0FAFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0027 44.233L49.7555 26.8887C43.2087 29.7061 38.9907 31.8884 38.2578 40.1941C41.2381 45.5032 48.3387 49.8515 57.0027 49.8515V44.233Z",
    fill: "#00274C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1719 46.2361C44.4324 46.4153 44.7256 46.5618 45.0024 46.741V43.3047L44.1719 46.2361Z",
    fill: "#00274C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0016 44.2333V48.6142L50.1779 36.3999L52.2136 33.9407L49.1193 32.8985L47.7188 27.7847L51.0899 26.3027L57.0016 44.2333Z",
    fill: "#0174A3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 28.4352L59.9477 31.3014L63.2537 26.4646L62.0323 25.7969C60.7946 27.0997 59.1009 27.9303 57 28.4352Z",
    fill: "#F0FAFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 44.233L64.2471 26.8887C70.794 29.7061 75.012 31.8884 75.7449 40.1941C72.7646 45.5032 65.664 49.8515 57 49.8515V44.233Z",
    fill: "#00274C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8384 46.2361C69.5778 46.4153 69.2847 46.5618 69.0078 46.741V43.3047L69.8384 46.2361Z",
    fill: "#00274C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 44.232V48.6128L63.8237 36.3986L61.788 33.9394L64.8823 32.8971L66.2829 27.7834L63.0257 26.334L57 44.232Z",
    fill: "#0A6D94"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8366 80.0273C32.0972 76.6724 33.2372 73.171 32.4066 70.0604C30.5012 65.6144 21.5114 63.5299 17.1957 64.3116C14.4923 68.8553 15.616 74.4576 16.1046 79.6364L31.8366 80.0273Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9219 79.8312V64.7344C27.6024 65.5975 31.2667 67.4215 32.4067 70.0598C33.221 73.1704 32.081 76.6718 31.8367 80.0267L23.9219 79.8312Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7891 111.459C26.1668 111.491 28.5119 111.394 30.8408 111.149V89.8803L30.0428 89.5383C28.3002 88.7728 26.1342 87.8934 23.7891 87.584V111.475V111.459Z",
    fill: "#63C0DA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7939 111.459C21.3999 111.491 19.0548 111.394 16.7422 111.149V89.8803L17.5402 89.5383C19.2828 88.7728 21.4488 87.8934 23.7939 87.584V111.475V111.459Z",
    fill: "#63C0DA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7578 83.3828H28.8224V89.4574C25.4675 92.1282 22.1127 92.226 18.7578 89.4574V83.3828Z",
    fill: "#E0AC7E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6411 70.9073C18.2242 70.6304 16.8562 72.0799 16.5956 73.513C16.3676 74.8322 16.1885 76.1676 16.1396 77.5193C16.1071 77.5193 16.3188 77.5193 16.0256 77.5193C15.7325 77.5193 14.8042 77.731 14.8368 78.985C14.8693 79.9133 15.6836 82.633 16.7585 82.1933C18.3056 86.3299 20.3902 88.675 23.7939 89.5056C23.8428 89.3916 23.8753 89.473 23.9242 89.4404V71.347C22.5562 71.347 21.1719 71.2167 19.6411 70.9073Z",
    fill: "#F2C196"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0722 70.9073C29.5053 70.6304 30.8571 72.0799 31.1176 73.513C31.3456 74.8322 31.5248 76.1676 31.5736 77.5193C31.6062 77.5193 31.3945 77.5193 31.6876 77.5193C31.9808 77.5193 32.9091 77.731 32.8765 78.985C32.8439 79.9133 32.0296 82.633 30.9548 82.1933C29.3913 86.395 27.2742 88.7076 23.7891 89.5056V71.3633C25.1571 71.3633 26.5413 71.233 28.0722 70.9236V70.9073Z",
    fill: "#EBB688"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7928 91.4918L20.8451 94.3581L17.5391 89.5212L18.7605 88.8535C19.9982 90.1564 21.6919 90.9869 23.7928 91.4918Z",
    fill: "#F0FAFC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7917 107.305L16.5446 89.9609C9.99773 92.7947 5.77973 94.9606 5.04688 103.266C8.02716 108.576 15.1277 112.924 23.7917 112.924V107.305Z",
    fill: "#00274C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9609 109.308C11.2215 109.488 11.5147 109.634 11.7915 109.813V106.377L10.9609 109.308Z",
    fill: "#00274C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7891 91.4918L26.7368 94.3581L30.0428 89.5212L28.8214 88.8535C27.5836 90.1564 25.8899 90.9869 23.7891 91.4918Z",
    fill: "#F0FAFC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7891 107.305L31.0362 89.9609C37.5831 92.7947 41.8011 94.9606 42.5339 103.266C39.5536 108.576 32.4531 112.924 23.7891 112.924V107.305Z",
    fill: "#00274C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6118 109.308C36.3513 109.488 36.0418 109.634 35.7812 109.813V106.377L36.6118 109.308Z",
    fill: "#00274C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2507 80.0273C98.5112 76.6724 99.6512 73.171 98.8206 70.0604C96.9152 65.6144 87.9255 63.5299 83.6098 64.3116C80.9064 68.8553 82.0301 74.4576 82.5186 79.6364L98.2507 80.0273Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3516 79.8312V64.7344C94.0321 65.5975 97.6964 67.4215 98.8364 70.0598C99.6507 73.1704 98.5107 76.6718 98.2664 80.0267L90.3516 79.8312Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2031 111.459C92.5808 111.491 94.9423 111.394 97.2548 111.149V89.8803L96.4568 89.5383C94.7143 88.7728 92.5483 87.8934 90.2031 87.584V111.475V111.459Z",
    fill: "#63C0DA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.208 111.459C87.8302 111.491 85.4688 111.394 83.1562 111.149V89.8803L83.9542 89.5383C85.6968 88.7728 87.8628 87.8934 90.208 87.584V111.475V111.459Z",
    fill: "#63C0DA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1719 83.3828H95.2364V89.4574C91.8816 92.1282 88.5267 92.226 85.1719 89.4574V83.3828Z",
    fill: "#E0AC7E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0711 70.9073C84.638 70.6304 83.2863 72.0799 83.0257 73.513C82.7977 74.8322 82.6185 76.1676 82.5697 77.5193C82.5371 77.5193 82.7488 77.5193 82.4557 77.5193C82.1625 77.5193 81.2343 77.731 81.2831 78.985C81.3157 79.9133 82.13 82.633 83.1885 82.1933C84.7357 86.3299 86.8203 88.675 90.224 89.5056C90.2891 89.3916 90.3054 89.473 90.3705 89.4404V71.347C89.0025 71.347 87.6183 71.2167 86.0874 70.9073H86.0711Z",
    fill: "#F2C196"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4869 70.9073C95.9038 70.6304 97.2718 72.0799 97.5324 73.513C97.7604 74.8322 97.9395 76.1676 97.9884 77.5193C98.0209 77.5193 97.8092 77.5193 98.1024 77.5193C98.3955 77.5193 99.3238 77.731 99.2749 78.985C99.2424 79.9133 98.4281 82.633 97.3695 82.1933C95.8061 86.395 93.6889 88.7076 90.1875 89.5056V71.3633C91.5555 71.3633 92.9398 71.233 94.4706 70.9236L94.4869 70.9073Z",
    fill: "#EBB688"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2068 91.4918L87.2591 94.3581L83.9531 89.5212L85.1746 88.8535C86.4123 90.1564 88.106 90.9869 90.2068 91.4918Z",
    fill: "#F0FAFC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2058 107.305L82.9586 89.9609C76.4118 92.7947 72.1938 94.9606 71.4609 103.266C74.4412 108.576 81.5418 112.924 90.2058 112.924V107.305Z",
    fill: "#00274C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3906 109.308C77.6512 109.488 77.9443 109.634 78.2212 109.813V106.377L77.3906 109.308Z",
    fill: "#00274C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2031 91.4918L93.1508 94.3581L96.4568 89.5212L95.2354 88.8535C93.9977 90.1564 92.304 90.9869 90.2031 91.4918Z",
    fill: "#F0FAFC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2031 107.305L97.4503 89.9609C103.997 92.7947 108.215 94.9606 108.948 103.266C105.968 108.576 98.8671 112.924 90.2031 112.924V107.305Z",
    fill: "#00274C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.042 109.308C102.781 109.488 102.488 109.634 102.211 109.813V106.377L103.042 109.308Z",
    fill: "#00274C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6821 55.9091C30.2063 51.3816 33.7566 47.4894 38.0235 44.5742C38.6912 45.5351 39.3915 46.5285 40.0918 47.5382C36.2972 50.1439 33.1215 53.5965 30.8578 57.6354L32.0466 58.2705L25.8906 63.7425L26.5909 55.3228L27.6821 55.9091Z",
    fill: "#63C0DA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8713 55.9091C84.347 51.3816 80.7967 47.4894 76.5299 44.5742C75.8459 45.5351 75.1619 46.5285 74.4453 47.5382C78.2399 50.1439 81.4156 53.5965 83.6793 57.6354L82.4905 58.2705L88.6465 63.7425L87.9462 55.3228L86.855 55.9091H86.8713Z",
    fill: "#63C0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDependant);
export default __webpack_public_path__ + "static/media/Dependant.4e84a5d5cc4c5b44273c9f4caf6823f7.svg";
export { ForwardRef as ReactComponent };